// =================================================== =================================================== CURSOR
const cursor = cursorDot({
    easing: 5
  });
console.log(cursor.parentElement);
cursor.over(".co-culture-s1", "co-culture-s1-cursor");

let canClick = true;

const containers = document.getElementsByClassName("co-culture-s1-entry");

for (let i = 0; i < containers.length; i++) {
  containers[i].addEventListener("mousedown", () => {
    if (!canClick) return;

    canClick = false;

    document.body.classList.add("co-body-click");

    // Remove the class on mouseup (anywhere on document)
    const removeClass = () => {
      document.body.classList.remove("co-body-click");
      document.removeEventListener("mouseup", removeClass);
    };

    document.addEventListener("mouseup", removeClass);

    // Re-enable click after 0.6s
    setTimeout(() => {
      canClick = true;
    }, 400);
  });
}


// =================================================== =================================================== CRACK
document.querySelectorAll('.co-culture-s1-entry').forEach(element => {
  let clickCount = 0;
  let lastClickTime = 0;

  element.addEventListener('mousedown', () => {
    const now = Date.now();

    // Prevent clicks faster than 0.5s and ignore after 3 clicks
    if (now - lastClickTime < 500 || clickCount >= 3) return;

    clickCount++;
    lastClickTime = now;

    // Remove all existing co-step-* classes
    element.classList.remove('co-step-1', 'co-step-2', 'co-step-3', 'co-step-4', 'co-step-5', 'co-step-6');

    // Add the new step class
    const stepClass = `co-step-${clickCount}`;
    element.classList.add(stepClass);

    // Chain final steps after the 3rd click
    if (clickCount === 3) {
      document.body.classList.add('co-body-cursor');
      setTimeout(() => {
        element.classList.remove('co-step-1', 'co-step-2', 'co-step-3');
        element.classList.add('co-step-4');

        setTimeout(() => {
          element.classList.remove('co-step-4');
          element.classList.add('co-step-5');

          setTimeout(() => {
            element.classList.remove('co-step-5');
            element.classList.add('co-step-6');
            
            document.body.classList.add('co-body-active');
            
            element.style.pointerEvents = 'none';
            element.style.display = 'none';
          }, 50);

        }, 400);

      }, 0);
    }
  });
});
